<script>
  import config from '../../libs/config.js';

  import api from '../../api'
  import _ from 'lodash'
  import { mapGetters, mapActions } from 'vuex'
  
  import func from '../../libs/functions.js';
  import _system from '../../libs/system'

	export default 
	{
		name: 'emailRender',
		data() 
        {
        	return {
            func:func,
            loading: false,
            decoded: ''
        	}
        },
        computed: {
          ...mapGetters('session', ['isLoggedIn', 'getUser']),
          ...mapGetters('tags', ['tags', 'tagsByName', 'tagsById']),
          ...mapGetters('message', ['getMessage']),
        },
      methods: {
        ...mapActions('tags', ['setTags']),
        ...mapActions('workspaces', ['setWorkspaces', 'pushWorkspace', 'setCurrentWorkspace']),
        ...mapActions('workspaceusers', ['setWorkspaceusers'])
      },
      mounted(){
/*           var st = document.getElementsByTagName('link');

            for(var i = 0 ; i < st.length ; i++){

                st[i].parentNode.removeChild(st[i]);

            } */

            
            if(!this.getMessage.replies) this.getMessage.replies = []

            this.getMessage.replies.unshift(this.getMessage);

            if(this.getMessage.replies && this.getMessage.replies.length){
              let found = _.find(this.getMessage.replies,{ _id: this.$route.query.messageId })
              this.decoded = found.html
            }
            


            

      },
      created(){

      }
	}
</script>

<template>
  <div style="padding: 1rem;" v-html="decoded"></div>
</template>



// WEBPACK FOOTER //
// src/components/dashboard/emailRender.vue